module.exports = __webpack_public_path__ + "img/date-icon.ce83c23f.svg";